import { Link } from "shared/components/Link";;
import { AppRoute } from "../../constants";
import ReportBuilder from "../../images/systemComponents/ReportBuilder.png";
import Title from "shared/components/Title";
import Layout from "../../components/Layout";
export const ReportBuilderPage = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    Конструктор отчетов
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Конструктор отчетов в SCADA NPT Compact — это мощный инструмент для создания, настройки и автоматизации генерации отчетов на основе данных, собираемых системой. Он используется для анализа, документирования и предоставления информации о работе технологических процессов.
                    </p>
                    <img
                        src={ReportBuilder}
                        className="mb-4  w-100"
                        alt="Конструктор отчетов"
                    />

                    <p>
                        Основные функции, для которых применяется конструктор отчетов:
                    </p>

                    <ul className="mb-4 description__list">
                        <li className="mb-1 description__number-li">Формирование стандартных и пользовательских отчетов
                            <ul>
                                <li className=" ">Создание отчетов по шаблонам, соответствующим требованиям предприятия.</li>
                                <li className=" ">Настройка индивидуальных отчетов с учетом специфики процессов.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Визуализация данных
                            <ul>
                                <li className=" ">Создание отчетов с графиками, диаграммами и таблицами для наглядного - представления информации.</li>
                                <li className=" ">Использование интерактивных элементов для детализации данных.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Анализ данных в реальном времени
                            <ul>
                                <li className=" ">Генерация отчетов на основе текущих данных (например, параметры оборудования, состояние процессов).</li>
                                <li className=" ">Отслеживание ключевых показателей эффективности (KPI).</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Исторический анализ данных
                            <ul>
                                <li className=" ">Создание отчетов на основе архивных данных для анализа тенденций и выявления проблем.</li>
                                <li className=" ">Исследование причин аварий или отклонений от нормы.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Автоматизация отчетности
                            <ul>
                                <li className=" ">Настройка автоматической генерации отчетов по расписанию (ежедневно, еженедельно, ежемесячно).</li>
                                <li className=" ">Отправка отчетов по электронной почте или сохранение их в заданных папках.</li>
                            </ul>
                        </li>

                    </ul>
                    <p>
                        Основные задачи, для которых применяется конструктор отчетов:
                    </p>

                    <ul className="mb-4 description__list">
                        <li className="mb-1 description__number-li">Контроль качества продукции
                            <ul>
                                <li className=" ">Формирование отчетов о качестве выпускаемой продукции на основе данных с датчиков и контроллеров.</li>
                                <li className=" ">Документирование параметров производства для соответствия стандартам.</li>
                            </ul>
                        </li>


                        <li className="mb-1 description__number-li">Планирование технического обслуживания
                            <ul>
                                <li className=" ">Генерация отчетов о состоянии оборудования для планирования ремонтов и обслуживания.</li>
                                <li className=" ">Анализ данных о наработке оборудования и частоте отказов.</li>
                            </ul>
                        </li>



                        <li className="mb-1 description__number-li">Энергоаудит и оптимизация ресурсов
                            <ul>
                                <li className=" ">Создание отчетов по потреблению энергии, воды, газа и других ресурсов.</li>
                                <li className=" ">Анализ данных для выявления возможностей снижения затрат.</li>
                            </ul>
                        </li>



                        <li className="mb-1 description__number-li">Документирование аварийных ситуаций
                            <ul>
                                <li className=" ">Автоматическое формирование отчетов о нештатных ситуациях (авариях, сбоях).</li>
                                <li className=" ">Фиксация времени, причин и последствий аварий для последующего анализа.</li>
                            </ul>
                        </li>



                        <li className="mb-1 description__number-li">Отчеты для руководства и внешних организаций
                            <ul>
                                <li className=" ">Подготовка сводных отчетов для руководства компании.</li>
                                <li className=" ">Формирование документов для предоставления контролирующим органам.</li>
                            </ul>
                        </li>


                    </ul>
                    <p>
                        <b>Примеры применения:</b>
                    </p>

                    <div><b>Энергетика:</b>  Отчеты о потреблении энергии, нагрузке на сети, авариях на подстанциях.</div>
                    <div><b>Нефтегазовая промышленность:</b>  Отчеты о добыче, транспортировке и переработке углеводородов.</div>
                    <div><b>Водоснабжение:</b> Отчеты о качестве воды, потреблении и авариях на сетях.</div>
                    <div><b>Производство: </b> Отчеты о выпуске продукции, простоях оборудования и качестве.</div>
                    <div><b>Транспорт:</b>  Отчеты о работе светофоров, загруженности дорог и инцидентах.</div>

                </div>

            </div>
        </div>
    </Layout>
}

export { ReportBuilderPage as Page }